import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';
import { Button } from '../ui/button';
import { Pause, Play } from 'lucide-react';

export function PauseOverlay({ isPaused, onResume }) {
  return (
    <Dialog open={isPaused} onOpenChange={() => {}}>
      <DialogContent className="sm:max-w-sm" hideCloseButton>
        <DialogHeader className="text-center">
          <div className="flex justify-center mb-4">
            <div className="bg-muted p-4 rounded-full">
              <Pause className="h-8 w-8 text-muted-foreground" />
            </div>
          </div>
          <DialogTitle className="font-heading">Game Paused</DialogTitle>
          <DialogDescription>
            Take a break! Your progress is saved.
          </DialogDescription>
        </DialogHeader>
        
        <Button onClick={onResume} className="w-full mt-4" size="lg">
          <Play className="h-4 w-4 mr-2" />
          Resume Game
        </Button>
      </DialogContent>
    </Dialog>
  );
}
